import { render, staticRenderFns } from "./DispositionRepresentative.vue?vue&type=template&id=881d1b48&scoped=true&lang=pug&"
import script from "./DispositionRepresentative.vue?vue&type=script&lang=ts&"
export * from "./DispositionRepresentative.vue?vue&type=script&lang=ts&"
import style0 from "./DispositionRepresentative.vue?vue&type=style&index=0&id=881d1b48&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "881d1b48",
  null
  
)

export default component.exports